<template>
  <div>
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      :showBranchSelector="false"
      @update:searchQuery="searchQuery = $event"
    />
    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" md="8" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title">Users List</h4>
              </div>
            </div>
            <div class="iq-card-body">
              <b-overlay :show="loading" rounded="sm" variant="Primary"></b-overlay>
              <b-table
                class="table b-table table-striped"
                :items="filteredLocalizedItems"
                :fields="columns.map(col => ({ key: col.prop, label: col.label }))"
                striped
                ref="table"
              >
                <template v-for="column in columns" #[`cell(${column.prop})`]="data">
                  <span v-if="!column.isAction">
                    {{ data.item[column.prop] || column.default }}
                  </span>
                  <span v-else>
                    <b-button
                      @click="editMenu(data.item)"
                      variant=" iq-bg-success mr-1 "
                      size="sm"
                    >
                      <i class="ri-ball-pen-fill"></i>
                    </b-button>
                  </span>
                </template>
              </b-table>
              <div class="mt-3 d-flex justify-content-center" v-if="!this.searchQuery">
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="fetchUsersList"
                />
              </div>
              <EmptySearchMessage v-if="searchQuery && filteredLocalizedItems.length <= 0"/>
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4" class="">
          <div class="iq-card ">
            <Create
              v-if="showAdd"
              :isInList="true"
              @onSubmit="fetchUsersList()"
              :business-id="businessId"
            />

            <Edit
              v-if="!showAdd && editModel"
              :isInList="true"
              @onSubmit="fetchUsersList()"
              :model="editModel"
              :showAdd="showAdd"
              @showAddChanged="updateShowAddState"
              :business-id="businessId"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Create from "./Create.vue";
import TableConfiguration from "./TableConfiguration";
import Edit from "./Edit.vue";
import { core } from "@/config/pluginInit";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";
import { getUsersList } from "@/API/UsersAPIs";
import moment from "moment";
export default {
  name: "UsersList",
  mixins: [TableConfiguration],
  components: { Create, Edit, SearchFilters, EmptySearchMessage },
  data() {
    return {
      loading: false,
      items: [],
      searchQuery: "",
      businessId: null,
      showAdd: true,
      editModel: null,
      showSearchBox: true
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    filteredLocalizedItems() {
      return this.items
    .filter(item =>
      item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    )
    .map(item => ({
      ...item,
      created_at: item.created_at ? moment(item.created_at).format("DD-MM-YYYY hh:mm A") : ""
    }));
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    }
  },

  watch: {
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
          this.fetchUsersList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    core.index();
  },
  methods: {
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    getLocalizedName(locales) {
      const locale = this.$i18n.locale || "en";
      const localizedData =
        locales.find(l => l.locale === locale) || locales[0];
      return localizedData ? localizedData.name : "No Name";
    },
    async fetchUsersList(page = 1) {
      if (!this.businessId) return;
      this.loading = true;
      try {
        const perPage = this.searchQuery
          ? this.paginationMeta.total
          : this.paginationMeta.per_page;
        const response = await getUsersList({
          businessId: this.businessId,
          "per-page": perPage,
          page
        });
        if (response && response.data) {
          this.items = response.data;
          this.paginationMeta = response.meta;
        }
      } catch (error) {
        console.error(error);
        this.items = [];
      }finally{
        this.loading = false;
      }
    },
    editMenu(model) {
      this.showAdd = false;
      this.editModel = model;
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  }
};
</script>

<style scoped></style>
